import { Button } from "components/ui/controls/Button"
import { ContentContainer } from "components/ui/display/ContentContainer"
import { Input } from "components/ui/inputs/Input"
import { AppLogo } from "components/ui/shared/AppLogo"
import { useErrors } from "providers/ErrorsProvider"
import { useContext, useState } from "react"
import styled from "styled-components"
import { MaterialIcon } from "components/ui/shared/MaterialIcon";
import { UserContext } from "providers/UserProvider"
import { replace, useNavigate } from "react-router-dom"

export const Login = () => {

    const [loginValues, setLoginValues] = useState({accessUsername: '', accessPassword: ''});
    const { setError, unsetError } = useErrors();
    const { authenticateUser } = useContext(UserContext);
    const navigate = useNavigate();

    const handleLoginValuesChange = (e) => {
        setLoginValues({
            ...loginValues,
            [e.target.name]: e.target.value
        });
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        if(loginValues.accessUsername.length < 3 || loginValues.accessPassword.length < 3)
        {
            setError("ACCESS_LOGIN_DETAILS_TOO_SHORT");
        }
        else
        {
            unsetError("ACCESS_LOGIN_DETAILS_TOO_SHORT");

            const success = await authenticateUser(loginValues.accessUsername, loginValues.accessPassword);

            if (!success) setError("ACCESS_LOGIN_DETAILS_WRONG");
            else
            {
                unsetError("ACCESS_LOGIN_DETAILS_WRONG");
                navigate('/dashboard', replace);
            }
        }
        
    }

    return (
        <StyledLogin>
            <AppLogo orientation="vertical" size='lg'/>
            <span className="loginDescription">Skriv inn brukernavn og passord.</span>
            <ContentContainer
                padding="lg"
                marginTop='lg'
                marginBottom='lg'
                width="350px"
                contentGap="lg"
            >
                <form className="loginContainerWrapper">
                    <Input
                        title="Brukernavn"
                        name='accessUsername'
                        prefix={<MaterialIcon name='person' weight={300} size='sm'/>}
                        onChange={handleLoginValuesChange}
                    />

                    <Input
                        title="Passord"
                        name='accessPassword'
                        type='password'
                        prefix={<MaterialIcon name='lock' weight={300} size='sm'/>}
                        onChange={handleLoginValuesChange}
                    />

                    <Button
                        type='primary'
                        text='Login'
                        onClick={handleLogin}
                        sufix={<MaterialIcon name='arrow_forward' weight={300}/>}
                    />
                </form>
                <div className="activateUserContainer">
                    <Button
                        type='tertiary'
                        text='Aktiver bruker'
                        onClick={() => navigate('/userAuth')}
                        width='fit'
                        prefix={<MaterialIcon name='lock_open_right' weight={300}/>}
                    />
                </div>
            </ContentContainer>
            <div className="undertext">
                Sikker arbeidsplass med begrenset tilgang.
            </div>
        </StyledLogin>
    )
}

const StyledLogin = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({theme}) => theme.spacing.md};

    span.loginDescription
    {
        font-weight: 400;
    }

    div.undertext
    {
        color: ${({theme}) => theme.colors.mutedForeground};
    }
`